import { TypedUseSelectorHook, useStore } from 'react-redux';
import { useSelector } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './frameworks_drivers/redux/reducers/rootReducer';
import { useDispatch } from 'react-redux';

//TODO: Remove this in the future because it's more maintainable and testable.
// Instead use the setupStore. Could not removed now because we have to many references to the store instance
const store = configureStore({
  reducer: rootReducer
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore: () => AppStore = useStore;

export default store;
